import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      companySummary: {
        YEARS: 'years',
        FISCAL_YEAR: 'Fiscal Year',
        VIEW_DETAIL: 'View details',
        COMPANY_OVERVIEW: 'Company Overview',
        OWNERSHIP_AND_GROUP: 'Ownership & Group',
        KEY_FINANCIALS: 'Key Financials',
        SCORE: 'Score',
        RECENT_NEWS: 'Recent News',
        COMPANY_ALERTS: 'Company Alerts',
        TOP_INDUSTRY_PLAYERS: 'Top Industry Players',
        TOP_COMPARABLE_PLAYERS: 'Top Comparable Players',
        FILING_STATUS: 'Filing Status',
        highlight: {
          LAST_UPDATE_DATE: 'LAST UPDATED DATE (SCORE)',
          CREDIT_RISK_SCORE: 'CORPORATE RISK SCORE',
          PERFORMANCE_SCORE: 'PERFORMANCE SCORE',
          YEAR_OF_OPERATIONS: 'YEARS IN OPERATION',
          CHARTER_CAPITAL: 'CHARTER CAPITAL',
          FISCAL_YEAR_END: 'FISCAL YEAR END',
          TOTAL_ASSETS: 'TOTAL ASSETS',
          BRANCHS: 'BRANCHES',
          SUBSIDIARIES: 'SUBSIDIARIES',
          TOTAL_OPERATING_INCOME: 'TOTAL OPERATING INCOME',
        },
        overview: {
          KEY_INFORMATION: 'Key Information',
          CONTACT: 'Contact',
          DATE_OF_REGISTRATION: 'Date of Registration',
          COMPANY_TYPE: 'Company Type',
          ACCOUNTING_PERIOD: 'Accounting Period',
          LEGAL_FORM: 'Legal Form',
          LEGAL_REPRESENTATIVE: 'Legal Representative',
          NUMBER_OF_EMPLOYEES: 'Number of Employees',
          WEBSITE: 'Website',
          EMAIL: 'Email',
          PHONE: 'Phone',
          FAX: 'Fax',
          ADDRESS: 'Address',
          companyType: {
            CT: 'Corporate',
            NH: 'Bank',
            CK: 'Securities',
            QU: 'Fund',
            FIO: 'Other Financial Institutions',
            BHNT: 'Life Insurance',
            BHPNT: 'Non-life Insurance',
            FIC: 'Finance Company',
            LEA: 'Leasing Company,',
          },
          NUMBER_OF_EMPLOYEES_TOOLTIP: 'Estimation',
        },
        ownershipGroup: {
          BRANCHES: 'BRANCHES',
          PARENT_COMPANIES: 'PARENT COMPANY',
          SUBSIDIARIES: 'SUBSIDIARIES',
          ASSOCIATES: 'ASSOCIATES',
          RELATED_COMPANIES: 'RELATED COMPANIES',
          OWNERSHIP_TYPES: 'OWNERSHIP TYPES',
        },
        keyFinancials: {
          INDICATOR: 'Indicator',
          UNIT: 'Unit',
          PERCENT_CHANGE: '% Change',
          TRENDLINE: 'Trendline',
        },
        score: {
          LAST_UPDATED_DATE: 'Last updated date: ',
          CORPORATE_CREDIT_RISK: 'Corporate Risk Score',
          PERFORMANCE: 'Performance Score',
          CORPORATE_PERFORMANCE: 'Corporate Performance Score',
          RISK_SCORE: 'Risk Score',
          DESCRIPTION: 'Description',
          FORECAST_PROBABILITY_12M: 'Probability of Default',
          FORECAST_PROBABILITY_24M: 'Financial Stress probability in 24 months',
          HIGH_GROWTH_12M: 'High Growth potential probability',
          HIGH_GROWTH_24M: 'High Growth potential probability in 24 months',
          NO_SCORE_DATA:
            'The score is not available due to the non-provision of data from the organization',
          TOOLTIP_CORPORATE_RISK_SCORE:
            'The Corporate Risk Score indicates a company’s likelihood of default, defined as ceasing operations within the next 12 months. Score range from 0 to 1000, with higher values indicating lower default risk. Each score range corresponds to a predefined Probability of Default (PD) based on a standardized Master Scale.',
        },
        recentNews: {
          SENTIMENT: 'Sentiment',
          HEADLINE: 'Headline',
          EVENT: 'Event',
          PUBLICATION_DATE: 'Publication Date',
        },
        companyAlerts: {
          NEGATIVE_ALERT: 'Negative Alerts',
          UNREAD_ALERT: 'Unread Alerts',
          TOTAL_ALERT: 'Total Alerts',
          STT: '#',
          TYPE_DESCRIPTION: 'Type/Description',
          DATE: 'Date',
          PORTFOLIO: 'Portfolio',
          CLICK_HERE: 'here',
          NO_ALERT_TO_DISPLAY: 'No alerts to display',
          USER_DISABLE_ALERT_1: 'This feature has been disabled.',
          USER_DISABLE_ALERT_2: 'Please click',
          USER_DISABLE_ALERT_3: "to change the company's alerts setting.",
        },
        topIndustryPlayers: {
          RANK: 'Rank',
          COMPANY_NAME: 'Company Name',
          REVENUE_IN: 'Revenue in',
          TOTAL_ASSETS_IN: 'Total Assets in',
          NET_REVENUE_IN: 'Net Revenue in',
          OPERATING_INCOME_IN: 'Operating Income in',
          REVENUE_INSURANCE_IN: 'Revenue from Insurance Premium in',
          COMPANY_REVENUE: "Company's Net Revenue",
          COMPANY_OPERATING_INCOME: "Company's Operating Income",
          BANK_TOTAL_ASSETS: "Bank's Total Assets",
          NON_BANK_TOTAL_ASSETS: "Non-Bank's Total Assets",
          LIFE_INSURANCE_REVENUE_INSURANCE:
            "Life Insurance's Revenue from Insurance Premium",
          NON_LIFE_INSURANCE_REVENUE_INSURANCE:
            "Non-Life Insurance's Revenue from Insurance Premium",
          TOOLTIP_TITLE:
            '<p>FiinGroup Company/Bank Rankings are the performance tables that judge size of companies/banks which register to operate in Vietnam. We use typical indicators to provide general comparisons.</p><p class="mt1">Companies/Banks are grouped into registered industries, then ranked by scale to suggest the position of the subject among its peers.</p><p class="mt1">The result is for reference only.</p>',
          TOOLTIP_REVENUE:
            'The Top Indutry Players are ranked using their Default Financial Statement (FS) data. A business can use multiple methods of recording FS resulting in a discrepancy between the number shown on this rating and the number in the FS when you change the default setting.',
        },
        topComparablePlayers: {
          LAST_UPDATED_DATE: 'Last updated date',
          RANK: 'Rank',
          COMPANY: 'Company',
          SIMILARITY_SCORE: 'Similarity Score',
          INDUSTRY: 'Industry',
          COMPANY_SIZE: 'Company Size',
          INVESTMENT_TYPE: 'Investment Type',
          INTERNATIONAL_TRADE: 'International Trade',
          TOOLTIP_TITLE:
            '<p>Business Similarity Score measures how closely a company\'s financial and industry profile matches other companies, based on key indicators such as revenue, total assets, and equity, alongside sector classification. Scores range from 0 to 100 — the higher the score, the closer the match.</p><p class="mt1">The table ranks the Top 10 most similar companies, enabling quick benchmarking of financial performance and relative positioning within peers of comparable size and industry.</p>',
        },
        filingStatus: {
          TYPE: 'Type',
          RECORD_AVAILABILITY: 'Record Availability',
          OVERDUE_TAX_DEBT: 'Overdue Tax Debt',
          OVERDUE_SOCIAL_INSURANCE_DEBT: 'Overdue Social Insurance Debt',
          INVOICE_ENFORMENT: 'Invoice Enforment History',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      companySummary: {
        YEARS: 'năm',
        FISCAL_YEAR: 'Năm Tài Chính',
        VIEW_DETAIL: 'Xem chi tiết',
        COMPANY_OVERVIEW: 'Thông Tin Tổng Quan',
        OWNERSHIP_AND_GROUP: 'Quan Hệ & Sở Hữu',
        KEY_FINANCIALS: 'Chỉ Số Tài Chính Trọng Yếu',
        SCORE: 'Điểm Số',
        RECENT_NEWS: 'Tin Tức Mới Nhất',
        COMPANY_ALERTS: 'Cảnh Báo',
        TOP_INDUSTRY_PLAYERS: 'Top Doanh Nghiệp',
        TOP_COMPARABLE_PLAYERS: 'Top Công Ty Tương Đồng',
        FILING_STATUS: 'Tình Trạng Nợ Thuế',
        highlight: {
          LAST_UPDATE_DATE: 'NGÀY CẬP NHẬT (ĐIỂM SỐ)',
          CREDIT_RISK_SCORE: 'ĐIỂM RỦI RO DOANH NGHIỆP',
          PERFORMANCE_SCORE: 'ĐIỂM TRIỂN VỌNG TĂNG TRƯỞNG',
          YEAR_OF_OPERATIONS: 'SỐ NĂM HOẠT ĐỘNG',
          CHARTER_CAPITAL: 'VỐN ĐIỀU LỆ',
          FISCAL_YEAR_END: 'KẾT THÚC NĂM TÀI CHÍNH',
          TOTAL_ASSETS: 'TỔNG TÀI SẢN',
          BRANCHS: 'CHI NHÁNH',
          SUBSIDIARIES: 'CÔNG TY CON',
          TOTAL_OPERATING_INCOME: 'TỔNG DOANH THU HOẠT ĐỘNG',
        },
        overview: {
          KEY_INFORMATION: 'Thông tin chính',
          CONTACT: 'Thông tin liên lạc',
          DATE_OF_REGISTRATION: 'Ngày Đăng Ký Kinh Doanh',
          COMPANY_TYPE: 'Loại Doanh Nghiệp',
          ACCOUNTING_PERIOD: 'Kỳ Kế Toán',
          LEGAL_FORM: 'Loại Hình Đăng Ký Doanh Nghiệp',
          LEGAL_REPRESENTATIVE: 'Người Đại Diện Pháp Luật',
          NUMBER_OF_EMPLOYEES: 'Số nhân viên',
          WEBSITE: 'Website',
          EMAIL: 'Email',
          PHONE: 'Điện thoại',
          FAX: 'Fax',
          ADDRESS: 'Địa Chỉ',
          companyType: {
            CT: 'Doanh nghiệp',
            NH: 'Ngân hàng',
            CK: 'Công ty chứng khoán',
            QU: 'Quỹ',
            FIO: 'Tổ chức tài chính khác',
            BHNT: 'Bảo hiểm nhân thọ',
            BHPNT: 'Bảo hiểm phi nhân thọ',
            FIC: 'Công ty tài chính',
            LEA: 'Cho thuê tài chính',
          },
          NUMBER_OF_EMPLOYEES_TOOLTIP: 'Ước tính',
        },
        ownershipGroup: {
          BRANCHES: 'Chi Nhánh',
          PARENT_COMPANIES: 'Công Ty Mẹ',
          SUBSIDIARIES: 'Công Ty Con',
          ASSOCIATES: 'Công Ty Liên Kết',
          RELATED_COMPANIES: 'Công Ty Liên Quan',
          OWNERSHIP_TYPES: 'Loại Hình Sở Hữu',
        },
        keyFinancials: {
          INDICATOR: 'Chỉ Tiêu',
          UNIT: 'Đơn Vị',
          PERCENT_CHANGE: '% Thay Đổi',
          TRENDLINE: 'Tăng Trưởng',
        },
        score: {
          LAST_UPDATED_DATE: 'Ngày cập nhật: ',
          CORPORATE_CREDIT_RISK: 'Điểm rủi ro doanh nghiệp',
          PERFORMANCE: 'Điểm Triển vọng Tăng trưởng',
          CORPORATE_PERFORMANCE: 'Điểm Triển Vọng Tăng Trưởng Doanh Nghiệp',
          RISK_SCORE: 'Hạng điểm',
          DESCRIPTION: 'Mô tả',
          FORECAST_PROBABILITY_12M: 'Xác suất vỡ nợ',
          FORECAST_PROBABILITY_24M:
            'Xác suất rơi vào khó khăn tài chính trong 24 tháng',
          HIGH_GROWTH_12M: 'Xác suất triển vọng tăng trưởng cao',
          HIGH_GROWTH_24M:
            'Xác suất triển vọng tăng trưởng cao trong 24 tháng tới',
          NO_SCORE_DATA:
            'Điểm số không khả dụng do doanh nghiệp không cung cấp dữ liệu',
          TOOLTIP_CORPORATE_RISK_SCORE:
            'Điểm rủi ro doanh nghiệp cho biết xác suất vỡ nợ của một doanh nghiệp, được định nghĩa là ngừng hoạt động trong vòng 12 tháng tới. Thang điểm từ 0 đến 1000, với điểm số cao hơn thể hiện rủi ro vỡ nợ thấp hơn. Mỗi khoảng điểm tương ứng với một xác suất vỡ nợ (PD) được chuẩn hóa theo thang điểm chuẩn.',
        },
        recentNews: {
          SENTIMENT: 'Trạng Thái',
          HEADLINE: 'Tiêu Đề',
          EVENT: 'Sự Kiện',
          PUBLICATION_DATE: 'Ngày Phát Hành',
        },
        companyAlerts: {
          NEGATIVE_ALERT: 'Cảnh báo tiêu cực',
          UNREAD_ALERT: 'Cảnh báo chưa đọc',
          TOTAL_ALERT: 'Tổng số cảnh báo',
          STT: '#',
          TYPE_DESCRIPTION: 'Loại Cảnh Báo/Mô Tả',
          DATE: 'Ngày',
          PORTFOLIO: 'Danh Mục',
          CLICK_HERE: 'vào đây',
          NO_ALERT_TO_DISPLAY: 'Không có cảnh báo phù hợp',
          USER_DISABLE_ALERT_1: 'Tính năng này đã bị tắt.',
          USER_DISABLE_ALERT_2: 'Vui lòng nhấp',
          USER_DISABLE_ALERT_3: 'để thay đổi cài đặt cảnh báo của công ty.',
        },
        topIndustryPlayers: {
          RANK: 'Thứ Hạng',
          COMPANY_NAME: 'Tên Công Ty',
          REVENUE_IN: 'Doanh Thu',
          TOTAL_ASSETS_IN: 'Tổng Tài Sản',
          NET_REVENUE_IN: 'Doanh Thu Thuần',
          OPERATING_INCOME_IN: 'Doanh Thu Hoạt Động',
          REVENUE_INSURANCE_IN: 'Doanh Thu Phí Bảo Hiểm',
          COMPANY_REVENUE: 'Doanh Thu Thuần của Công ty',
          COMPANY_OPERATING_INCOME: 'Doanh Thu Hoạt Động của Công Ty',
          BANK_TOTAL_ASSETS: 'Tổng Tài Sản của Ngân Hàng',
          NON_BANK_TOTAL_ASSETS: 'Tổng Tài Sản của Tổ Chức Tài Chính',
          LIFE_INSURANCE_REVENUE_INSURANCE:
            'Doanh Thu Phí Bảo Hiểm của Bảo Hiểm Nhân Thọ',
          NON_LIFE_INSURANCE_REVENUE_INSURANCE:
            'Doanh Thu Phí Bảo Hiểm của Bảo Hiểm Phi Nhân Thọ',
          TOOLTIP_TITLE:
            '<p>Bảng xếp hạng Công ty/ Ngân hàng của FiinGroup là bảng đánh giá quy mô của các công ty/ ngân hàng đăng ký hoạt động tại Việt Nam. Chúng tôi sử dụng các chỉ số tiêu biểu để đưa ra các so sánh chung.</p><p class="mt1">Các công ty/ ngân hàng được nhóm lại theo các ngành đã đăng ký, sau đó xếp hạng theo độ lớn để đề xuất vị trí của nó so với các doanh nghiệp cùng ngành.</p><p class="mt1">Kết quả chỉ mang tính chất tham khảo.</p>',
          TOOLTIP_REVENUE:
            'Top doanh nghiệp trong ngành được xếp hạng dựa trên dữ liệu Báo cáo tài chính (BCTC) mặc định của mỗi công ty. Một doanh nghiệp có thể sử dụng nhiều phương pháp ghi nhận BCTC dẫn đến chênh lệch giữa con số thể hiện trên xếp hạng này và số trong BCTC khi bạn thay đổi cài đặt mặc định.',
        },
        topComparablePlayers: {
          LAST_UPDATED_DATE: 'Ngày cập nhật gần nhất',
          RANK: 'Hạng',
          COMPANY: 'Công ty',
          SIMILARITY_SCORE: 'Mức Tương Đồng',
          INDUSTRY: 'Ngành',
          COMPANY_SIZE: 'Quy Mô',
          INVESTMENT_TYPE: 'Loại Hình Đầu Tư',
          INTERNATIONAL_TRADE: 'Giao Thương Quốc Tế',
          TOOLTIP_TITLE:
            '<p>Điểm tương đồng doanh nghiệp cho biết mức độ giống nhau về đặc điểm kinh doanh giữa doanh nghiệp đang xem và các doanh nghiệp khác, được xác định dựa trên việc so sánh các chỉ số tài chính (doanh thu, tổng tài sản, vốn chủ sở hữu...) và ngành nghề kinh doanh. Thang điểm từ 0 đến 100, với điểm số càng cao thể hiện mức độ tương đồng càng lớn.</p><p class="mt1">Danh sách hiển thị Top 10 doanh nghiệp có điểm tương đồng cao nhất, dùng để benchmark, đối chiếu chỉ số tài chính và xếp hạng tương đối trong nhóm doanh nghiệp cùng quy mô, ngành nghề.</p>',
        },
        filingStatus: {
          TYPE: 'Loại',
          RECORD_AVAILABILITY: 'Bản Ghi Khả Dụng',
          OVERDUE_TAX_DEBT: 'Quá hạn nợ thuế',
          OVERDUE_SOCIAL_INSURANCE_DEBT: 'Quá hạn nợ bảo hiểm xã hội',
          INVOICE_ENFORMENT: 'Lịch sử cưỡng chế hóa đơn',
        },
      },
    },
  }),
)
